import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core'
import { FormControl } from '@angular/forms'
import { FloatLabelType, MatFormField } from '@angular/material/form-field'
import { MatSelectChange } from '@angular/material/select'
import { MatSelectOptionVm } from '@view/matieral/select.view'

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent {
  @Input() control: FormControl | null = null
  @Input() floatLabel: FloatLabelType = 'always' //auto' //'always'
  @Input() labelText: string = ''
  @Input() selected: string | null = ''
  @Input() placeholderText: string = ''
  @Input() errorMessage: string = ''
  @Input() options: MatSelectOptionVm[] = []
  @Output() changeEvent = new EventEmitter<MatSelectChange>()

  @ViewChild(MatFormField, { read: ElementRef }) matFormField!: ElementRef

  constructor(private renderer: Renderer2) {}

  ngAfterViewChecked() {
    if (this.errorMessage && this.matFormField) {
      this.addInvalidClass()
    } else if (this.matFormField) {
      this.removeInvalidClass()
    }
  }

  get showSelect(): boolean {
    return this.options.length > 0
  }
  handleSelectChange($event: MatSelectChange) {
    this.changeEvent.next($event)
  }

  private addInvalidClass() {
    const formFieldElement = this.matFormField.nativeElement
    this.renderer.addClass(formFieldElement, 'mat-form-field-invalid')
    const wrapper = formFieldElement.querySelector('.mdc-text-field')
    if (wrapper) {
      this.renderer.addClass(wrapper, 'mdc-text-field--invalid')
    }
  }

  private removeInvalidClass() {
    const formFieldElement = this.matFormField.nativeElement
    this.renderer.removeClass(formFieldElement, 'mat-form-field-invalid')
    const wrapper = formFieldElement.querySelector('.mdc-text-field')
    if (wrapper) {
      this.renderer.removeClass(wrapper, 'mdc-text-field--invalid')
    }
  }
}
